import { useMutation, useQueryClient } from '@tanstack/react-query';

import { changeRenewalStatus } from '../api/ChangeRenewalStatus';

interface ChangeRenewalStatusParams {
  renewalUuid: string;
  status: string;
}

export const useChangeRenewalStatus = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ renewalUuid, status }: ChangeRenewalStatusParams) =>
      changeRenewalStatus(renewalUuid, status),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['renewals'] });
      queryClient.invalidateQueries({
        queryKey: ['renewal', variables.renewalUuid],
      });
    },
  });

  return {
    changeStatus: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
